import React, { useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Select,
  MenuItem, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// import { Button } from 'bootstrap';

export default function ReturnTable({ totalLoan, rows, callProducts, products, returnProd }) {
  //console.log(rows.length)
    const [openRows, setOpenRows] = useState({}); 
    const [selectedQuantities, setSelectedQuantities] = useState(1);
    const [open, setOpen] = useState(false);
    const [selectedProd, setSelectedProd] = useState();

    const handleOpen = (prod, row) => {
      setSelectedProd(prod) 
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
  
    const handleConfirm = (confirm) => {
      setOpen(false);
      doRefund(confirm); // Pass `true` for payReceive if required
    };
  const toggleRow = (purchaseOrderId) => {
    setOpenRows((prev) => ({
        [purchaseOrderId]: !prev[purchaseOrderId] // Only the clicked row toggles, others collapse
    }));
  };

  const passBillId = (purchaseId) => { 
    if (purchaseId) {
      callProducts(purchaseId);
    }
  };

  const handleSelectChange = (productId, value) => {
    // setSelectedQuantities((prev) => ({  value }));
    setSelectedQuantities(value)
  };

  const doRefund = (confirm) => {
    const amount = parseFloat(selectedProd?.unit_price * selectedQuantities)
    let totalValue = parseFloat(selectedProd?.quantity_left) * parseFloat(selectedProd?.last_average_price)
    let actualVale = totalValue - parseFloat(amount)
    let averagePrice = actualVale / (parseFloat(selectedProd?.quantity_left) - parseFloat(selectedQuantities))
    let roznamchaCashAmount = 0   
    if(amount > parseFloat(totalLoan?.amount_remaining)){ // 100 > 0, 100 > 50,  120 -180
      confirm = 'Yes';
      roznamchaCashAmount = (amount - parseFloat(totalLoan?.amount_remaining))
    }
    else{ // 10 > 100
      confirm = 'No'
    }
    const refund = {
      returnQuantity : selectedQuantities,
      amount: amount,
      productId: selectedProd.product_id,
      payReceive : confirm,
      pOrderId: selectedProd?.purchase_order_id,
      remaininQuantity: selectedProd?.quantity_left,
      averagePrice:  isNaN(averagePrice) ? selectedProd?.last_average_price : averagePrice,
      roznamchaCashAmount,
      selectedProd
    }
    returnProd(refund)
    //console.log(refund)
  }
  const calculateRefundAmount = (product, row) => { 
    const refundAmount = selectedQuantities * product.unit_price ; 
    return refundAmount.toFixed(2);
  };
  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table>
            <TableBody>
              {rows.length === 0 ?
                    <TableRow>
                      <TableCell><h2 style={{textAlign: 'center', color: '#f44336'}}>تر وسه کوم بل ندی جوړ سوی</h2></TableCell>
                    </TableRow>
              : null}
              {rows.map((row) => (
                <React.Fragment key={row.purchase_order_id}>
                  <TableRow>
                    <TableCell>
                      <IconButton size="small" onClick={() => {toggleRow(row.purchase_order_id); passBillId(row.purchase_order_id);}} >
                        {openRows[row.purchase_order_id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </IconButton>
                    </TableCell>
                    <TableCell>{row.created_at}</TableCell>
                    <TableCell>{row.old_bill_num}زاړه بل شمیره:  </TableCell>
                    <TableCell>{row.total_amount} ټوټل بل
                        {/* {row?.payments?.length > 0 ?  */}
                        <>
                        <br/>
                        {/* Paid {row?.payments[0]?.amount_out} */}
                        <br/>
                        {/* Loan {row?.total_amount - row?.payments[0]?.amount_out} */}
                        </>
                        {/* : null} */}
                    </TableCell>
                  </TableRow> 
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                      <Collapse in={openRows[row.purchase_order_id]} timeout="auto" unmountOnExit >
                        <Box margin={1}>
                          <Table size="small" aria-label="products">
                            {/* <TableHead>
                              <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Total</TableCell>
                                <TableCell>Description</TableCell>
                              </TableRow>
                            </TableHead> */}
                            <TableBody>
                              {(products?.data || []).map((prod, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{prod.product_name}<br />{prod.product_code}<br />{prod.batchnumber}</TableCell>
                                  <TableCell>{`${prod.unit_price} x ${prod.quantity_ordered} = ${prod.quantity_ordered * prod.unit_price}`}</TableCell>
                                  <TableCell>
                                    {
                                      prod?.quantity_left > 0 ? 
                                      <>
                                        <Select value={selectedQuantities || 1} onChange={(e) => handleSelectChange(prod?.product_id, e.target.value)}>
                                          {[...Array(Math.floor(prod?.quantity_left > prod?.quantity_ordered ? prod?.quantity_ordered : prod?.quantity_left)).keys()].map((num) => (
                                            <MenuItem key={num + 1} value={num + 1}>{num + 1}</MenuItem>
                                          ))}
                                        </Select>
                                        <Button 
                                          variant="contained" 
                                          onClick={() => handleOpen(prod, row)} 
                                          color="secondary">
                                          {calculateRefundAmount(prod, row)} واپس
                                        </Button>
                                      </> : 
                                      <>پلورل شوی</>
                                    }
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Dialog open={open} minWidth='md' fullWidth maxWidth='xs' onClose={handleClose}>
        <DialogTitle>مهرباني وکړئ تایید کړئ</DialogTitle>
        <DialogContent>
        <DialogContentText>
          {` ټوټل  [${(selectedQuantities * selectedProd?.unit_price)}]افغانی واپس کیږی`}
        </DialogContentText>
         {totalLoan?.amount_remaining > 0  &&  totalLoan?.amount_remaining >= (selectedQuantities * selectedProd?.unit_price)? (
          <> 
            <DialogContentText>
              {`${totalLoan?.supplier_name} پر مونږ باندی [${totalLoan?.amount_remaining}] پورپاته دي د`}
            </DialogContentText>
            <DialogContentText>
              {`دا ${selectedQuantities * selectedProd?.unit_price} افغانی به د هغه په ​​پور کې حساب سي چی پور یی کم سی`}
            </DialogContentText>
            </>
          ) :
            totalLoan?.amount_remaining > 0  &&  totalLoan?.amount_remaining < (selectedQuantities * selectedProd?.unit_price)? (
            <> 
              <DialogContentText>
                {`${totalLoan?.supplier_name} پر مونږ باندی [${totalLoan?.amount_remaining}] پورپاته دي د`}
              </DialogContentText>
              <DialogContentText>
                {`دا ${totalLoan?.amount_remaining} افغانی به د هغه په ​​پور کې حساب سي چی پور یی ختم سی`}
              </DialogContentText>
              <DialogContentText>
                {`دا ${(selectedQuantities * selectedProd?.unit_price) - totalLoan?.amount_remaining} افغانی به دخل ته ولاړی سی`}
              </DialogContentText>
              </>
            ) : (
              <DialogContentText>
                {`ایا تاسو اوس ${selectedQuantities * selectedProd?.unit_price} افغانی نغدی ترلاسه کړې؟`}
              </DialogContentText>
            )}
      </DialogContent>

        <DialogActions style={{fontSize:'25px'}}>
          <Button onClick={() => handleConfirm('Yes')} color="primary">تایید</Button>
          {/* <Button onClick={() => handleConfirm('No')} color="primary">یا</Button> */}
          <Button onClick={handleClose} color="secondary" autoFocus>کینسل</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
